import { AxiosInstance } from 'axios';
import * as FileSaver from 'file-saver';
import { insertId } from '../insertId';

export default (api: AxiosInstance, url: string) => async (bulkId: number) => {
  const urlWithId = insertId(url, bulkId);

  const response = await api.get(urlWithId, {
    responseType: 'blob',
  });
  const header = response.headers['content-disposition'];
  const filename = header.split('filename=')[1];
  FileSaver.saveAs(response.data, filename);
};



// WEBPACK FOOTER //
// ./src/services/api/linkUpload/downloadBulkExcel.ts